module.exports = __webpack_public_path__ + "img/save.9538f03d.png";